'use client'

import { cn } from '@/lib/utils'

export function MeseroFrame({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className="min-h-dvh bg-[#0a0a0c] p-0 sm:p-6 flex justify-center">
      <div
        className={cn(
          'w-full h-dvh sm:w-[390px] sm:h-[844px] sm:rounded-[44px] overflow-hidden sm:border sm:border-white/10 bg-[#0f0f11] flex flex-col',
          className,
        )}
      >
        {children}
      </div>
    </div>
  )
}

